































import Vue from 'vue';

// Types and services
import { CourseraCourse, CourseraProgram } from '~/models/coursera';

// Components
import CourseraHeader from './CourseraHeader.vue';
import CourseraBody from './CourseraBody.vue';
import CourseraService from '~/services/CourseraService';
import Spinner from '~/components/builders/Spinner.vue';
import Header from '~/components/layouts/Header.vue';
import NavLink from '~/components/navigation/NavLink.vue';

export default Vue.extend({
    name: 'CourseraLanding',
    components: {
        CourseraHeader,
        CourseraBody,
        Spinner,
        Header,
        NavLink,
    },
    data() {
        return {
            program: null as CourseraProgram | null,
            hasAccess: false,
            loading: true,
            error: false,

            searchCourse: null as CourseraCourse | null,
        };
    },
    created() {
        CourseraService.getProgram()
            .then(program => (this.program = program))
            .catch(reason => {
                console.error(reason);
                this.error = true;
            })
            .finally(() => (this.loading = false));

        CourseraService.checkHasAccess().then(acc => (this.hasAccess = acc.access));
    },
});
